import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/main/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/visualizations/main/table',
      params,
    });
  },
});
